var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.50519 12.7498C1.56607 11.1224 2.04355 9.04833 3.59847 7.99505L3.60013 7.99338C4.84923 7.14926 6.49331 7.17759 7.71325 8.06421L10.2873 9.93578C11.5064 10.8224 13.1505 10.8507 14.4004 10.0066L14.4021 10.0049C15.9578 8.95166 16.4361 6.87594 15.4953 5.25019M12.7515 15.4945C11.1241 16.4336 9.04999 15.9561 7.99671 14.4012L7.99505 14.3995C7.15093 13.1504 7.17926 11.5063 8.06588 10.2864L9.93744 7.71238C10.8241 6.49327 10.8524 4.84919 10.0083 3.59926L10.0049 3.59759C8.95166 2.04351 6.87594 1.56437 5.25019 2.50515M14.3029 3.69676C17.2319 6.62577 17.2319 11.3739 14.3029 14.3029C11.3739 17.2319 6.62577 17.2319 3.69676 14.3029C0.767747 11.3739 0.767747 6.62577 3.69676 3.69676C6.62577 0.767747 11.3739 0.767747 14.3029 3.69676Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.68c17855952bad0f5a1008d34fe8113a.svg";
export { ForwardRef as ReactComponent };